<!--
 * @Description: 最新报警
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-11-22 09:17:45
 * @LastEditTime: 2024-05-16 11:33:25
-->
<template>
<div class="statisticalChartsContainer">
  <!-- 最新报警 -->
  <div class="chartItem">
    <div class="itemBox" v-if="isShow">
      <div class="chartBox" id="pBox">
        <ul ref="listRoll">
          <li v-for="(item,i) in rencentDataList" :key="i">
            <h6>
              <span>{{item.content}}</span>
              <span>{{item.createTime}}</span>
            </h6>
            <p> <span>设备: </span> {{item.deviceName}}[{{item.deviceIMEI}}]</p>
            <p> <span>状态: </span> {{item.isHandle ? "已处理" : "未处理"}}</p>
            <p> <span>地址: </span> {{item.deviceInstallLocation}}</p>
          </li>
        </ul>
      </div>
    </div>
    <img src="../../assets/img/bigScreen/noData.png" alt="" v-else>
    <!-- <el-empty :image="imgSrc" :image-size="80" description="30分钟内无报警" v-else></el-empty> -->
  </div>
</div>
</template>

<script>
export default {
  props: {
    flag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rencentDataList:[],
      isShow: true,
      imgSrc: require('../../assets/img/bigScreen/no-data.png'),
      timmer: null
    }
  },
  computed: {
    idName() {
      return this.flag ? "echartsId10_big" : "echartsId10"
    },
    alarms() {
      return this.$store.state.alarm;
    },
  },
  created () {
    // this.getEchartsList();
  },
  mounted () {
    this.setRoll()
  },
  watch:{
    alarms(curval,oldval){
      // this.getEchartsList()
      this.setRoll()
    }
  },
  methods: {
    /**
     * @Description 数据请求
     * @Author      YOYO     -             2021-11-23
     */
    async getEchartsList () {
      const {code,msg,data} = await this.request.post('/front/alarm/record/getNewestAlarms?minutes=60')
      if (code!==200) {
        if (code == 500) {
          this.isShow = false
          return this.$message.error(msg)
        }
        return
      }
      this.isShow = data.length > 0

      this.rencentDataList = data
    },
    /**
     * @Description 请求数据后，在做轮播效果
     * @Author      YOYO - 2021-11-23
     */
    async setRoll () {
      await this.getEchartsList()

      if (!this.isShow) return

      let ulDom = this.$refs.listRoll
      let pDom = document.getElementById('pBox')

      if (ulDom.offsetHeight <= pDom.offsetHeight) return

      // 为实现无缝滚动，需要复制一份数据衔接一下
      let list = JSON.parse(JSON.stringify(this.rencentDataList))
      this.rencentDataList = this.rencentDataList.concat(list)

      let temp = 0
      let flag = 0
      this.timmer && clearInterval(this.timmer)
      this.timmer = setInterval(() =>{
        temp--
        if (temp == -93) {
          let item1 = this.rencentDataList[0]
          this.rencentDataList.splice(0, 1)
          this.$nextTick(() => {
            temp = 0
          })
          this.rencentDataList.push(item1)
        }
        this.$nextTick(() => {
          ulDom.style.transform = `translateY(${temp}px)`
        })
        // if (temp < -ulDom.offsetHeight + 80) {
        //   flag = 1
        // }
        // if (temp > 0) {
        //   flag = 0
        // }
        // flag == 0 ? temp-- : temp++
        // ulDom.style.transform = `translateY(${temp}px)`
      }, 40);
    }
  },
  destroyed () {
    this.timmer && clearInterval(this.timmer)
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/bigScreen/card-box.png') no-repeat;
  background-size: 100% 100%;  

  .chartItem {
    width: 100%;
    height: 100%;
    >img {
      width: 90%;
      height: 90%;
      margin: 5%;
    }

    .itemBox {
      width: 100%;
      height: 100%;
      scrollbar-width: none;
      -ms-overflow-style: none;

      ::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
      }

      // #echartsId10 {
      //   font-size: 12px;

      //   .item {
      //     .left {
      //       font-size: 30px;
      //     }
      //   }
      // }
      // #echartsId10_big {
      //     font-size: 20px;
      //     overflow: auto;
      //   .item {
      //     .left {
      //       font-size: 100px;
      //     }
      //   }
      // }

      .chartBox {
        width: 100%;
        height: 96%;
        color: #fff;
        overflow: hidden;
        ul {
          width: 90%;
          margin: 0 auto;
        }
        li {
          width: 100%;
          margin-top: 8px;
          border: 1px solid #132B4B;
          h6 {
            color: #FA0101;
            font-size: 12px;
            width: 94%;
            height: 26px;
            margin: 0 auto;
            border-bottom: 1px solid #132B4B;
            >span {
              display: inline-block;
              width: calc(100% - 122px);
              line-height: 26px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &:last-child {
                float: right;
                width: 120px;
              }
            }
          }
          >p {
            font-size: 12px;
            width: 94%;
            margin: 2px auto;
            span {
              color: #02D9FD;
            }
          }
        }
        // background: rgba(29, 55, 82, 0.85);
        // .chartBoxCon {
        //    width: 100%;
        //   height: 100%;
        //   display: flex;
        //   flex-direction: column;
        //   overflow: auto;
        // }

        // /* IE 10+ */
        // .item {
        //   flex: 1;
        //   height: 100%;
        //   display: flex;

        //   .left {
        //     color: red;
        //     padding-left: 2.5%;
        //     position: relative;

        //     i {
        //       position: absolute;
        //       top: 50%;
        //       transform: translateY(-50%);
        //     }
        //   }

        //   .right {
        //     padding-left: 15%;
        //     padding-top: 5%;
        //     flex: 1;
        //     display: flex;
        //     flex-direction: column;

        //     .top {
        //       flex: 1;
        //       display: flex;
        //       justify-content: space-between;
        //       color: red;

        //       .topRight {
        //         padding-right: 5%;
        //       }

        //     }

        //     .rightItem {
        //       flex: 1;
        //       display: flex;
        //       color: #fff;
        //     }

        //   }
        // }
      }
    }
  }
}
</style>
